<template>
    <div class="input layout-inline">
        <template v-for="option in options">
            <div
                :key="option.value"
                class="onboarding-select"
            >
                <input
                    :id="`answer-${ controlName }-${ option.value }`"
                    type="radio"
                    :value="option.value"
                    @change="$event.target.checked && onChange($event.target)"
                >
                <label :for="`answer-${ controlName }-${ option.value }`">{{ option.label }}</label>
            </div>
        </template>

        <div
            v-if="inputVisible"
            class="extra-field"
        >
            <fieldset class="no-label">
                <input
                    v-model="value"
                    type="text"
                    required=""
                    autocomplete="off"
                    @input="updateValue()"
                >
            </fieldset>
        </div>
    </div>
</template>

<script>
import { find } from 'lodash';

export default {
    props: {
        options: {
            type: Array,
            default: () => ([]),
        },
        controlName: {
            type: String,
            default: '',
        },
        userAnswer: {
            type: String,
            default: '',
        },
        inputKey: {
            type: String,
            default: 'other',
        },
    },

    /**
     * @returns {object} Data object.
     */
    data() {
        return {
            initialValue: null,
            value: null,
            inputVisible: false,
            lastSelected: null,
        };
    },

    /**
     * Created hook. Stores initial value.
     *
     * @returns {void}
     */
    created() {
        this.initialValue = this.userAnswer;
    },

    /**
     * Mounted hook. Checks initially selected answer.
     *
     * @returns {void}
     */
    mounted() {
        if (! this.userAnswer) {
            return;
        }

        // Use 'other' as checked value to display text input if needed
        const checkedValue = this.isOther() ? this.inputKey : this.userAnswer;
        const checkedItem = this.$el.querySelector(`input[value="${checkedValue}"]`);

        if (checkedItem) {
            const event = document.createEvent('HTMLEvents');

            checkedItem.checked = true;
            event.initEvent('change', false, true);
            checkedItem.dispatchEvent(event);
        }
    },

    methods: {
        /**
         * Whether this control has 'other' answer
         *
         * @returns {boolean} Has other option.
         */
        hasOther() {
            return !! find(this.options, { value: this.inputKey });
        },

        /**
         * Whether the answer is other than available options (needs text input).
         *
         * @returns {boolean} Whether the other option is selected.
         */
        isOther() {
            return this.hasOther() && ! find(this.options, { value: this.initialValue });
        },

        /**
         * Change item value.
         *
         * @param {HTMLElement} item Input field.
         * @returns {void}
         */
        onChange(item) {
            if (this.lastSelected) {
                this.lastSelected.checked = false;
            }

            this.lastSelected = item;

            if ((item.value === this.inputKey)) {
                this.value = this.isOther() ? this.initialValue : '';
                this.inputVisible = true;
            } else {
                this.value = item.value;
                this.inputVisible = false;
                this.updateValue();
            }
        },

        /**
         * Emits 'input' event
         */
        updateValue() {
            this.$event.$emit('update-anwser', {
                control: this.controlName,
                answer: this.value,
            });
        },
    },
};
</script>
